import React from 'react'
import { actualitiesLink, directLink, homeLink } from '../constants/endspoints'
import { NavLink } from 'react-router-dom'
import OffcanvasMenu from './OffcanvasMenu'

const BottomMobileNav = () => {

    const arrayNav = [
        {
            name: 'Accueil',
            icon: 'fa-light fa-house',
            link: homeLink
        },
        {
            name: 'Grille TV',
            icon: 'fa-light fa-tv',
            link: directLink
        },
        {
            name: 'Actualités',
            icon: 'fa-light fa-bell',
            link: actualitiesLink
        },
        {
            name: 'Menu',
            icon: 'fa-light fa-bars',
        }
    ]

    return (
        <div className=' bottom-mobile-nav bg-black'>
            <div className='d-md-none d-flex py-2 row gx-1 gx-sm-4 justify-content-around align-items-center text-white'>
                {
                    arrayNav.map((nav, index) => (
                        nav.link ? (
                            <NavLink to={nav.link} className='d-flex flex-column justify-content-center align-items-center text-white main-nav-link-mobile col h-100' key={index}>
                                <i className={`${nav.icon} fs-9s`}></i>
                                <p className='mb-0 fs-7s text-nowrap'>{nav.name}</p>
                            </NavLink>
                        ) : (
                            <div role='button' data-bs-toggle="offcanvas" data-bs-target="#mobileNav" className='d-flex flex-column justify-content-center align-items-center text-white main-nav-link-mobile col h-100' key={index}>
                                <i className={`${nav.icon} fs-9s`}></i>
                                <p className='mb-0 fs-7s text-nowrap'>{nav.name}</p>
                            </div>
                        )
                    ))
                }
            </div>


            <OffcanvasMenu/>
        </div>
    )
}

export default BottomMobileNav